import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup/redux/RootReducer";

interface ErrorDetails {
  timestamp: string;
  path: string;
  referenceID: string;
}

const initialState = {
  ShowErrorMessage: false,
  ErrorMessage: "",
  ErrorDetails: undefined as ErrorDetails | undefined,
};

export const errorAlertSlice = createSlice({
  name: "errorAlert",
  initialState,
  reducers: {
    setShowErrorMessage: (state, action) => {
      state.ShowErrorMessage = action.payload;
    },
    setErrorMessage: (state, action) => {
      let message = action.payload;

      try {
        const parsed = JSON.parse(message);
        if (parsed?.message) {
          message = parsed.message;
          state.ErrorDetails = {
            timestamp: parsed.timestamp,
            path: parsed.path,
            referenceID: parsed.reference,
          };
        }
      } catch {
        state.ErrorMessage = action.payload;
      }
      state.ErrorMessage = message;
      state.ShowErrorMessage = true;
    },
    clearError: (state) => {
      state.ShowErrorMessage = false;
      state.ErrorMessage = "";
      state.ErrorDetails = undefined;
    },
  },
});

export const { setShowErrorMessage, setErrorMessage, clearError } = errorAlertSlice.actions;
export const selectShowErrorMessage = (state: RootState) => state.errorAlert.ShowErrorMessage;
export const selectErrorMessage = (state: RootState) => state.errorAlert.ErrorMessage;
export const selectErrorDetails = (state: RootState) => state.errorAlert.ErrorDetails;
export default errorAlertSlice.reducer;
